<div class="progress">
  <span class="cp-donut-percentual"><p class="cp-donut-text-percentual">{{ value }}%</p></span>
  <span class="cp-donut-legend" [style.color]="strokeColor">{{ literalsCp?.strEntregue }}</span>
	<svg class="progress__svg" width="120" height="120" viewBox="0 0 140 160">
		<circle class="progress__meter" cx="70" cy="75" [attr.r]="radius" stroke-width="32" />
		<circle class="progress__value" [style.stroke]="strokeColor" [style.strokeDasharray]="circumference" [style.strokeDashoffset]="dashoffset" cx="70" cy="75"
		 [attr.r]="radius" stroke-width="33" />
	</svg>
</div>
